














import { Component, Vue, Watch, Emit, Prop } from 'vue-property-decorator';
@Component
export default class CommonScreenTop extends Vue {
    @Prop() private screenTitle!: string;
    @Prop() private screenRemarks!: string;
    @Prop() private errorMessage!: string;
    @Prop() private infoMessage!: string;
}
